import Card from "../components/Card";
import StatusContent from "./StatusContent";

function StatusCard() {
  const statusContents = [
    {
      key: 1,
      title: "Not Submitted",
      description: "unpermitted",
      vesselCount: 300,
      percentage: 13,
      color: "#FF3452",
      strokeDashOffset: 400,
    },
    {
      key: 2,
      title: "In Review",
      description: "in review",
      vesselCount: 576,
      percentage: 25,
      color: "#FBC059",
      strokeDashOffset: 300,
    },
    {
      key: 3,
      title: "Approved",
      description: "approved",
      vesselCount: 1430,
      percentage: 62,
      color: "#23E8A1",
      strokeDashOffset: 150,
    },
  ];

  return (
    <>
      {statusContents.map((status) => (
        <Card
          key={status.key}
          custom="w-[32.7%]"
          borderRadius="rounded-2xl"
          innerContent={
            <StatusContent
              title={status.title}
              description={status.description}
              vesselCount={status.vesselCount}
              percentage={status.percentage}
              color={status.color}
              strokeDashOffset={status.strokeDashOffset}
            />
          }
        />
      ))}
    </>
  );
}

export default StatusCard;
